import React from "react";
import { CheckCircle2, Info, TriangleAlert, X, XCircle } from "lucide-react";

function iconForType(type) {
  if (type === "error") return XCircle;
  if (type === "warning") return TriangleAlert;
  if (type === "success") return CheckCircle2;
  return Info;
}

function stylesForType(type) {
  if (type === "error") {
    return { border: "border-destructive/30", icon: "text-destructive" };
  }
  if (type === "warning") {
    return { border: "border-warning/30", icon: "text-warning" };
  }
  if (type === "success") {
    return { border: "border-success/30", icon: "text-success" };
  }
  return { border: "border-accent/30", icon: "text-accent" };
}

export default function PopupCenter({ popups, onDismiss }) {
  if (!popups?.length) return null;

  return (
    <div className="fixed top-20 sm:top-24 right-3 sm:right-5 z-[9999] flex flex-col gap-2 max-w-[calc(100vw-1.5rem)] sm:max-w-sm pointer-events-none">
      {popups.map((popup) => {
        const Icon = iconForType(popup.type);
        const tone = stylesForType(popup.type);
        return (
          <div
            key={popup.id}
            role="alert"
            className={`pointer-events-auto rounded-xl border ${tone.border} bg-card shadow-lg px-4 py-3 animate-[slide-down_0.2s_var(--ease-smooth)]`}
          >
            <div className="flex items-start gap-2.5">
              <Icon className={`h-4 w-4 mt-0.5 shrink-0 ${tone.icon}`} />
              <div className="min-w-0 flex-1">
                <div className="flex items-start justify-between gap-2">
                  <p className="text-sm font-medium text-foreground leading-snug">
                    {popup.title || "Notification"}
                  </p>
                  <button
                    type="button"
                    onClick={() => onDismiss(popup.id)}
                    className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full hover:bg-foreground/5 text-muted-foreground transition-colors"
                    aria-label="Dismiss"
                  >
                    <X className="h-3.5 w-3.5" />
                  </button>
                </div>
                {popup.message ? (
                  <p className="mt-0.5 text-xs text-muted-foreground leading-relaxed line-clamp-2">
                    {popup.message}
                  </p>
                ) : null}
                {popup.action ? <div className="mt-2">{popup.action}</div> : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
